<app-dropdown 
    [options]="transactionProviders"
    [valueFormControl]="valueFormControl"
    [showToggleAll]="true"
    [fieldPlaceholder]="'export-creation.fields.provider.placeholder' | translate">
</app-dropdown>
